import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { appPaths } from '@/app/router/paths.js';
import { isDesignSystemPreviewEnabled } from '@/shared/config/design-system-preview.js';

interface RequireDesignSystemPreviewProps {
  children: ReactNode;
}

export function RequireDesignSystemPreview({ children }: RequireDesignSystemPreviewProps) {
  if (!isDesignSystemPreviewEnabled()) {
    return <Navigate to={appPaths.home} replace />;
  }

  return children;
}
